module.exports = __webpack_public_path__ + "media/flags/sd-c00a8e48.svg";